export function buildModulesTable(template, values, contrato) {
  // 1. Reemplazar todas las variables {{...}} en el template
  let html = template;
  for (const [key, value] of Object.entries(values)) {
    html = html.replaceAll(key, value ?? "");
  }

  /* // 2. Generar la tabla de módulos con contratos_modulos
  const modulos = contrato.contratos_modulos ?? [];
  const rows = modulos
    .map(
      (item) => `
      <tr>
        <td>${item.nombre}</td>
        <td>1</td>
        <td>${item.valor_total.toLocaleString("es-CO")}</td>
      </tr>
    `
    )
    .join("");

  const tabla = `
    <table border="1" width="100%">
      <thead>
        <tr>
          <th>Módulo</th>
          <th>Cantidad</th>
          <th>Valor</th>
        </tr>
      </thead>
      <tbody>${rows}</tbody>
    </table>
  `;

  // 3. Si el template tiene {{tabla_modulos}}, reemplazarlo; si no, appendear
  if (html.includes("{{tabla_modulos}}")) {
    html = html.replaceAll("{{tabla_modulos}}", tabla);
  } else {
    html += tabla;
  } */

  return html;
}